import { render, staticRenderFns } from "./unitOverview.vue?vue&type=template&id=3347e243&scoped=true&"
import script from "./unitOverview.vue?vue&type=script&lang=js&"
export * from "./unitOverview.vue?vue&type=script&lang=js&"
import style0 from "./unitOverview.vue?vue&type=style&index=0&id=3347e243&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3347e243",
  null
  
)

export default component.exports